export default __webpack_public_path__ + "static/media/early-access.cc131120.webp";